import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  SHOPIFY_CHANNEL_TYPE,
  getPendingShopifyChannel,
  mapSyncStrategyToApi,
} from '../../components/teammates/views/Channels/helpers/salesChannelState';

export const saveSalesChannelSyncStrategy = createAsyncThunk(
  'salesChannels/saveSalesChannelSyncStrategy',
  async ({ syncStrategy, salesChannelId }, { extra: { sdk, Logger }, getState }) => {
    const resolvedSalesChannelId = salesChannelId || getPendingShopifyChannel(getState().user?.team)?._id;

    try {
      const { data } = await sdk.setup.saveSalesChannel({
        type: SHOPIFY_CHANNEL_TYPE,
        salesChannelId: resolvedSalesChannelId,
        syncStrategy: mapSyncStrategyToApi(syncStrategy),
      });
      return data;
    } catch (error) {
      Logger.error(
        new Error('Save sales channel sync strategy failed'),
        { error },
        ['ConnectShopifyChSaveSyncFailed', {}],
      );
      throw error;
    }
  },
);
